import React, { useEffect, useState } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import ActionBtn from "./ActionBtn";

import styles from "./ListWrapper.module.scss";

type Props = {
  pageTitle?: string;
  btnTitle?: string;
  icon?: IconProp;
  handler?: () => void;
  tabs?: Array<string>;
  clearHandler?: () => void;
  link?: string;
  children: React.ReactNode;
};

const ListWrapper: React.FC<Props> = ({
  pageTitle,
  btnTitle,
  icon,
  handler,
  tabs,
  clearHandler,
  link,
  children,
}) => {
  const [selectTab, setSelectTab] = useState("");

  useEffect(() => {
    if (tabs && tabs.length > 0) {
      setSelectTab(tabs[0]);
    }
  }, []);

  const handleSelectTab = (tab: string) => {
    setSelectTab(tab);

    if (clearHandler) {
      clearHandler();
    }
  };

  return (
    <div className={styles["f-listWrapper"]}>
      <div className={styles["f-listWrapper__header"]}>
        <div className={styles["f-listWrapper__header-title"]}>{pageTitle}</div>
        {btnTitle ? (
          <ActionBtn
            label={btnTitle}
            icon={icon ?? ["fal", "user-plus"]}
            link={link}
            onClick={handler}
          />
        ) : null}
      </div>
      <div className={styles["f-listWrapper__content"]}>
        {tabs && tabs.length > 0 ? (
          <>
            <ul
              className={styles["f-listWrapper__content-tabs"]}
              role="tablist"
            >
              {tabs.map((tab, i) => (
                <li
                  key={i}
                  className={
                    selectTab === tab
                      ? `${styles["f-listWrapper__content-tabs-tab"]} ${styles["selected"]}`
                      : styles["f-listWrapper__content-tabs-tab"]
                  }
                  role="presentation"
                >
                  <button
                    type="button"
                    tabIndex={selectTab === tab ? 0 : -1}
                    role="tab"
                    aria-controls={tab}
                    aria-selected={selectTab === tab ? true : false}
                    onClick={() => {
                      handleSelectTab(tab);
                    }}
                  >
                    {tab}
                  </button>
                </li>
              ))}
            </ul>
            <div className={styles["f-listWrapper__content-list"]}>
              {React.Children.map(children, (content, i) => {
                if (selectTab === tabs[i]) {
                  return (
                    <div
                      id={tabs[i]}
                      key={i}
                      role="tabpanel"
                      hidden={selectTab === tabs[i] ? false : true}
                    >
                      {content}
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          </>
        ) : (
          <div className={styles["f-listWrapper__content-list"]}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListWrapper;
